import ReportedHolrsTable from './ReportedHolrsTable';

export default ReportedHolrsTable;
